export function generateLinkWhatsapp(text: string) {
  const phone = '628113655800'
  const queries = new URLSearchParams({
    text: text,
  })

  return `https://wa.me/${phone}?${queries}`
}
